import css from  './Select.css'
import { on, ready, query, queryAll } from '../../lib/dom.js'
import { hide, show, fireEvent } from '../../lib/jsfunc.js'

ready(function(){
  on(document.body, 'click', function(event){
    if(event.target.matches('.Select,.Select-text,.Select-img')){
      return false;
    }

    var targetClass = event.target.classList[0];

    if( targetClass && event.target.matches('.CONTENT_WRAPPER,.circle-links,.circle-rechts,.GRID,.GRID_WIDE_COLUMN,.GRID_NARROW_COLUMN')){
      var ul = queryAll('.SelectOptions > ul');
      for(var i=0;i<ul.length;++i){
        if(!ul[i].matches('.hidden')){
          hide(ul[i]);
        }
      }
    }
  })
})

on('click', '.Select,.select-text,.SelectExpander,.SelectExpander span.img', function(event) {
  event.preventDefault();
  var ul, div, selkey;

  div = event.target.closest('.Select');
  if(!div){
    return false;
  }
  ul = query(div, '.SelectOptions>ul');
  if(!ul.matches('.hidden')){
    hide(ul);
  }else{
    selkey = query(div, 'input[type=hidden]').value;
    query(ul, 'li[data-key="'+selkey+'"]').classList.add('selected');
    show(ul);
    return false;
  }
})

  // Klick auf Selectbox Element
on('click','.SelectOptions>ul li', function(event) {
  event.preventDefault();
  var ul, div, selkey, input;
  var li = event.target;
  if(li.tagName != 'LI'){
    li = event.target.closest('li')
  }
  div = li.closest('.Select');
  if(!div){
    return false;
  }

  ul = query(div, '.SelectOptions>ul');

  selkey = li.getAttribute('data-key');
  input = query(div, 'input[type=hidden]');

  hide(ul);
  if(selkey != input.value){
    input.value = selkey;
    fireEvent(input, 'change');
  }
  event.stopPropagation();
})

on('mouseover','.SelectOptions>ul li', function(event) {
  event.preventDefault();
  var ul = event.target.closest('ul');
  var li = query(ul, 'li.selected');
  if(li){
    li.classList.remove('selected');
  }
})

on('change', '.Select input[type=hidden]', function(event){
  event.preventDefault();
  var selkey = event.target.value;
  var div = event.target.closest('div.Select');

  if(!div){
    return false;
  }

  var li = query(div, 'li[data-key="'+selkey+'"]');
  var divSel = query(div, '.SelectContent > div');
  divSel.outerHTML = li.innerHTML;
  var uls = queryAll('.SelectOptions>ul');
  for(var i=0;i<uls.length;++i){
    if(uls[i].visibility == 'visible'){
        hide(uls[i]);
      }
  }
})

// global change
on('change', '.Panel.panel-produkte input[type=hidden]', function(event){
  event.preventDefault();

  var div = event.target.closest('div.Select');
  var url = query(div, '.SelectProdukteLi').getAttribute('data-url');
  //window.location = url;
})

on('change', 'select.paymentMethod', function(event){
  var error = query('.shop.payment tr.error');
  if(error){
    hide(error);
  }
})